
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/beacon",
      function () {
        return require("private-next-pages/docs/beacon/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/beacon"])
      });
    }
  